import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setOpenModalTerceirosInformativo, setRedirectTerceiros } from "../../../../../store/actions/termos";
import ModalInformativo from "../../../../../components/ModalInformativo";

export default function ModalTerceirosInformativo() {
  const terceirosReducer = useSelector((state) => state.terceiros);
  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(setOpenModalTerceirosInformativo(false));
    dispatch(setRedirectTerceiros(true));
  };
  
  const handleModal = () => {
    dispatch(setOpenModalTerceirosInformativo(false));
    dispatch(setRedirectTerceiros(true));
  };
  
  const handleModalStorage = () => {
    dispatch(setOpenModalTerceirosInformativo(false));
    localStorage.setItem("naoExibirTerceirosInformativo", true);
    dispatch(setRedirectTerceiros(true));
  };

  return (
    terceirosReducer.openModalInformativo && (
      <ModalInformativo
        onClose={() => closeModal()}
        onConfirm={() => handleModal()}
        handleModalStorage={() => handleModalStorage()}
        title="Informativo: Novidades sobre as Contribuições para Terceiros"
        buttonText="OK"
        MessageInline="Não exibir mais esta mensagem"
        width={800}
        height={600}
      >
        O STJ publicou recentemente o acórdão que definiu que o limite de 20 salários-mínimos não se aplica à base de cálculo das contribuições para terceiros, dentro do Tema Repetitivo 1.079.
        Isso significa que a limitação de 20 salários-mínimos não incidirá sobre as contribuições destinadas às entidades do Sistema S, como SENAI, SESI, SESC e SENAC.
        A Corte modulou os efeitos de sua decisão. Isso garante que nada mudará para os contribuintes que já obtiveram decisão favorável, judicial ou administrativamente, até 25/10/2023, data do início do julgamento.
        <br />
        <br />
        Este módulo do e-Recuperador continua disponível para esses contribuintes. Utilize-o para recalcular as contribuições de terceiros caso tenha decisão favorável até 25/10/2023.
      </ModalInformativo>
    )
  );
};
